var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.88834 10.6574C7.9017 10.6744 7.91878 10.6883 7.93827 10.6977C7.95776 10.7072 7.97916 10.7122 8.00084 10.7122C8.02252 10.7122 8.04392 10.7072 8.06341 10.6977C8.0829 10.6883 8.09998 10.6744 8.11334 10.6574L10.1133 8.12701C10.1866 8.03415 10.1205 7.89665 10.0008 7.89665H8.67763V1.85379C8.67763 1.77522 8.61334 1.71094 8.53477 1.71094H7.46334C7.38477 1.71094 7.32048 1.77522 7.32048 1.85379V7.89487H6.00084C5.8812 7.89487 5.81512 8.03237 5.88834 8.12522L7.88834 10.6574ZM14.5366 10.0324H13.4651C13.3866 10.0324 13.3223 10.0967 13.3223 10.1752V12.9252H2.67941V10.1752C2.67941 10.0967 2.61512 10.0324 2.53655 10.0324H1.46512C1.38655 10.0324 1.32227 10.0967 1.32227 10.1752V13.7109C1.32227 14.027 1.57762 14.2824 1.89369 14.2824H14.108C14.4241 14.2824 14.6794 14.027 14.6794 13.7109V10.1752C14.6794 10.0967 14.6151 10.0324 14.5366 10.0324Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.7b2e87cd4eb4eb86d80d3d33ae0b95ff.svg";
export { ForwardRef as ReactComponent };